import React from 'react';
import styled from 'styled-components';
import PhotoCards from './PhotoCards';

const Container = styled.section`
    grid-row: 2;
    grid-column: 1;
    margin-top: 3rem;
    opacity: 87%;

    @media (min-width: 1024px) {
        margin-top: 0;
    }
`;

const Date = styled.p`
    font-size: clamp(0.8rem, 0.8vw + 0.3rem, 1.1rem);
    font-weight: 300;
`;

const Title = styled.h1`
    font-size: clamp(1.75rem, 2vw + 0.75rem, 3rem);
    margin: 0 0 1rem 0;
`;

const Description = styled.span`
    margin-bottom: 2rem;
    font-size: clamp(1rem, 1vw + 0.35rem, 1.35rem);
    display: flex;
    flex-direction: column;
    gap: 1rem;

    a {
        color: #a1a1a1;
        text-decoration: none;
    }
`;

const DescriptionAfter = styled.span`
    margin-top: 1rem;
    font-size: clamp(1rem, 1vw + 0.35rem, 1.35rem);
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &:after {
        content: '';
        right: 32rem;
        top: 44.3rem;
        width: 0.2rem;
        height: 1.6rem;
        background: #ffffff;
        animation: cursor-blink 1s steps(2) infinite;
    }

    a {
        color: #a1a1a1;
        text-decoration: none;
    }
`;

const Text = `
    i'm fullstack developer in system integration
    and user web applications, based in moscow, russia.
    main focus – complex interfaces, api integration
    and stable fullstack solutions.
    i have 5+ years of experience and love what i do.
`;

const SecondText = `
    i work with react, typescript, redux and python —
    i participate in architectural design, develop large
    features and bring them to production. i love tasks
    where you need to understand complex logic, optimise
    processes and find an elegant technical solution.

    i value strong teams and knowledge sharing —
    conducting code reviews, learning from colleagues
    and mentoring developers. i'm equally comfortable
    taking full ownership of a feature solo and
    driving it to release.

    outside of work i volunteer as the head of the
    'centre for animal care' group, helping shelters
    and organising support for animals.

    in my free time i do sports, read tech and fiction,
    and love exploring complex systems —
    in code and in life.
`;

const ThirdText = `
    i will be glad to cooperate!
`;

const AboutMe = () => {
    return (
        <Container>
            <Date>16 march 2022, 17:45</Date>
            <Title>ABOUT ME</Title>
            <Description>
                <span>
                    {Text}also, u can download my cv{' '}
                    <a href='https://drive.google.com/file/d/16n0FVFgm1TUf5B-TbZrYfbrGoYQ7pX6M/view?usp=sharing'>
                        here
                    </a>
                    .
                </span>
            </Description>
            <PhotoCards />
            <DescriptionAfter>
                {SecondText}
                <br />
                <br />
                {ThirdText}
            </DescriptionAfter>
        </Container>
    );
};

export default AboutMe;
